import * as Icons from "../assets/SVGs/index";
import Button from "./basicComponents/button";
import {setIsModalOpen,setModalData,} from "../state-management/actions/global-state-actions";
import { useDispatch } from "react-redux";

const DeleteButton = ({ id, handleDelete }: { id: string; handleDelete: () => void }) => {
  const dispatch = useDispatch();

  const openModal = () => {
    dispatch(
      setModalData(
        "حذف",
        "آیا از حذف این سطر اطمینان دارید؟",
        "حذف",
        handleDelete,
        id
      )
    );
    dispatch(setIsModalOpen(true));
  };

  return <Button title="" icon={<Icons.DeleteIcon />} onClick={openModal} />;
};

export default DeleteButton;

